import { OverallValidationResult, validator } from '../../../../../tradebuilder-v2/util'
import { SetEconomicsFormState } from '../set-economics-slice'
import { setEconomicsRules } from './set-economics'

const setEconomicsValidator = validator(setEconomicsRules)

export function validate(economicsState: SetEconomicsFormState): OverallValidationResult {
  return setEconomicsValidator(economicsState)
}
